import script from "./TopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TopComponent.vue?vue&type=script&setup=true&lang=js"

import "./TopComponent.vue?vue&type=style&index=0&id=d5bba88e&lang=css"
import "./TopComponent.vue?vue&type=style&index=1&id=d5bba88e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5bba88e"]])

export default __exports__